import { media } from '../styles/MediaQueries';
import { isBrowser } from './isBrowser';

const mediaQueryPhonablet = isBrowser ? window.matchMedia(media.phonablet) : undefined;

export const isMobile = () => mediaQueryPhonablet?.matches;
